export default __webpack_public_path__ + "static/media/6300-series-Oxygen-Trap.364c970e.jpg";